import React, { useEffect, useState } from "react";

/**
 * Indicador de estado de red.
 *
 * En operación de campo no alcanza con que la app "funcione igual" sin
 * conexión: el piloto tiene que saber que la elevación y la meteorología que
 * está viendo pueden venir de caché. Sin esta señal, un dato viejo se lee
 * como un dato actual.
 *
 * navigator.onLine solo detecta si hay interfaz de red levantada, no si hay
 * salida real a internet. La verificación activa contra el propio servidor
 * llega en la Fase 2, junto con la cola de sincronización.
 */
export default function OfflineBar() {
  const [enLinea, setEnLinea] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );
  const [desde, setDesde] = useState(null);

  useEffect(() => {
    const conectar = () => {
      setEnLinea(true);
      setDesde(null);
    };
    const desconectar = () => {
      setEnLinea(false);
      setDesde(new Date());
    };

    window.addEventListener("online", conectar);
    window.addEventListener("offline", desconectar);
    return () => {
      window.removeEventListener("online", conectar);
      window.removeEventListener("offline", desconectar);
    };
  }, []);

  if (enLinea) return null;

  const hora = desde
    ? desde.toLocaleTimeString("es", { hour: "2-digit", minute: "2-digit" })
    : null;

  return (
    <div className="hc-bar hc-bar--offline" role="status" aria-live="polite">
      <span aria-hidden="true">⛔</span>
      <span>
        Sin conexión{hora ? ` desde las ${hora}` : ""}. Elevación y meteorología pueden estar
        desactualizadas — verifique la hora de cada dato antes de usarlo.
      </span>
    </div>
  );
}
